import Splash from '@/commons/splash';
import {useAuthContext} from '@/hooks/useAuthContext';
import BranchSelectPage from '@/modules/branch/pages/select';
import {Navigate} from 'react-router-dom';
import {ReactElement} from "react";

export default function BranchRedirect(): ReactElement | null {
    const {isInitialized, logout, user} = useAuthContext();

    if (!isInitialized) {
        return <Splash/>;
    }
    if (!user) {
        logout();
        return <Navigate to="/auth/login"/>;
    }
    if (user?.branchSelected) {
        return <Navigate to="/dashboard/app"/>;
    }
    if (!user?.branchSelected) {
        return <BranchSelectPage/>;
    }
    return null
}
